<div class='width-1100'>

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>bookmark</mat-icon>
        <div>
          <span>Certificados Inscritos • </span>
          <span>{{title}}&nbsp;</span>
        </div>
      </div>

    </mat-toolbar>
  </mat-card>

  <div class='content'>

    <mat-card style="display: flex; flex-direction: row; justify-content: space-between;">
      <div style="display: flex; flex-direction: column; ">
        <mat-label>Eventos</mat-label>
        <mat-select (ngModelChange)="eventChange($event)" [ngModel]="selectedEvent"
          style="border: solid 1px silver; width: 800px; padding: 5px; margin: 5px 0 15px 0;">
          <mat-option *ngFor="let event of arrayEvents" [value]="event">
            <span>{{ event.name }}</span>
          </mat-option>
        </mat-select>
      </div>

      <div *ngIf="selectedEvent" style="margin-top: 20px;">
        <button mat-raised-button (click)='openCertificateConfigDialog()' style="margin-right: 10px;">
          Configurações
        </button>
      </div>

    </mat-card>

    <mat-card *ngIf="subscriptionDataSource">
      <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro' autocomplete="off">

      <mat-table [dataSource]="subscriptionDataSource" style='height: calc(100vh - 400px); overflow:auto;'>

        <ng-container matColumnDef="icon">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon style='color:rgba(0,0,0,.8); font-size:1.4em;'>bookmark</mat-icon>
          </mat-cell>
        </ng-container>


        <ng-container matColumnDef="member_name">
          <mat-header-cell *matHeaderCellDef> Inscrito </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.member_name }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="product_name">
          <mat-header-cell *matHeaderCellDef> Evento </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.event_name }} </mat-cell>
        </ng-container>


        <ng-container matColumnDef="view">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <a *ngIf="element.certificate_url" matTooltip="Visualizar" target='_blank' href={{element.certificate_url}}>
              <mat-icon>remove_red_eye</mat-icon>
            </a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="selected">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox color='primary' #checkbox (change)='toggleCheckUsers(checkbox.checked)'>
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div>
              <mat-checkbox color='primary' [(ngModel)]="element.selected">
              </mat-checkbox>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedCertificateColumns">
        </mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedCertificateColumns;">
        </mat-row>

      </mat-table>

    </mat-card>
  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button *ngIf="subscriptionDataSource" mat-raised-button (click)='updateSubscriptionEnrollments()'>
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>